/**
 * AI Context Store — shares wizard state with AI Assistant drawer
 */
import { create } from 'zustand';

export interface AIContext {
  datasetName?: string;
  fileName?: string;
  schema?: { columnName: string; dataType: string }[];
  filePreview?: string[][];
  wizardStep?: number;
}

interface AIContextStore {
  context: AIContext;
  setContext: (ctx: Partial<AIContext>) => void;
  clearContext: () => void;
}

export const useAIContext = create<AIContextStore>((set) => ({
  context: {},
  setContext: (ctx) => set((s) => ({ context: { ...s.context, ...ctx } })),
  clearContext: () => set({ context: {} }),
}));
